import { Globe } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from "./ui/dropdown-menu";

export function LanguageSwitcher({ variant = "default" }) {
    const { lang, setLang, languages } = useLanguage();
    const current = languages.find((l) => l.code === lang) || languages[0];

    const triggerBase = "inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-border bg-white hover:bg-accent/40 transition-colors text-sm font-medium flex-shrink-0";
    const triggerCompact = "inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md hover:bg-accent/40 transition-colors text-xs font-medium text-muted-foreground flex-shrink-0";

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className={variant === "compact" ? triggerCompact : triggerBase}
                data-testid="language-switcher-trigger"
                aria-label="Change language"
            >
                <Globe className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="mono tracking-wide" data-testid="language-switcher-current">{current.short}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" data-testid="language-switcher-menu">
                {languages.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        onClick={() => setLang(l.code)}
                        className={l.code === lang ? "bg-accent/40 font-medium" : ""}
                        data-testid={`language-option-${l.code}`}
                    >
                        <span className="mono w-7 tracking-wide">{l.short}</span>
                        <span>{l.label}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
